import React from 'react';
import { Router } from 'react-router-dom';
import Routes from 'Source/routes';
import { History } from 'history';
import { ApolloProvider } from '@apollo/client';
import useHiddenOutline from 'Hooks/useHiddenOutline';
import { AuthProvider } from 'Components/utils/AuthContext';
import UIProviders from 'Components/utils/UIProviders';
import ErrorBoundary from 'Components/ErrorBoundary';
import { createApolloClient } from 'Source/apollo';
import { AppConfigProvider } from 'Components/utils/AppBootstrapper/AppConfigContext';
import SplitProvider from 'Components/utils/SplitProvider';

interface AppProps {
  history: History;
}

const App: React.FC<AppProps> = ({ history }) => {
  useHiddenOutline();

  const client = React.useMemo(() => createApolloClient(history), [history]);
  return (
    <ErrorBoundary fallbackStrategy="passthrough">
      <ApolloProvider client={client}>
        <AuthProvider>
          <AppConfigProvider>
            <SplitProvider>
              {/* @ts-ignore should be fixed with react-router@v6 */}
              <Router history={history}>
                <UIProviders>
                  <Routes />
                </UIProviders>
              </Router>
            </SplitProvider>
          </AppConfigProvider>
        </AuthProvider>
      </ApolloProvider>
    </ErrorBoundary>
  );
};

export default App;
